import {AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {CustomerSearchService} from "../../events/customer-search.service";
import {SideBarService} from "../site-layout/sidebar.service";
import {DeviceDetectorService} from "ngx-device-detector";
import {TranslateService} from "@ngx-translate/core";
import {RegistryService} from "../../services/registry.service";
import {environment} from "../../../../environments/environment";
import {OnlineStatusService, OnlineStatusType} from "ngx-online-status";
import {MatSnackBar} from "@angular/material/snack-bar";
import {IconSnackBarComponent} from "../../components/icon-snackbar/icon-snack-bar.component";
import {faWifi, faWifiSlash} from "@fortawesome/pro-regular-svg-icons";

@Component({
    selector: 'app-site-header',
    templateUrl: './site-header.component.html',
    styleUrls: ['./site-header.component.css']
})
export class SiteHeaderComponent implements OnInit, AfterViewInit {

    showFiller = false;
    @ViewChild('headerDiv', {static: true}) headerElement: ElementRef;

    sticky = false;
    env = environment
    sidebar = null;
    elementPosition: any;
    isMobile = true;
    showMobileAppsDownloadComp = true;

    constructor(public router: Router,
                private customerSearchService: CustomerSearchService,
                private sideBarService: SideBarService,
                private deviceService: DeviceDetectorService,
                private translate: TranslateService,
                private registry: RegistryService,
                private snackbar: MatSnackBar,
                private onlineStatusService: OnlineStatusService
    ) {


        this.router.routeReuseStrategy.shouldReuseRoute = () => {
            return false;
        };

        this.onlineStatusService.status.subscribe((status: OnlineStatusType) => {
            // Retrieve Online status Type
            let icon;
            let color;
            if (status == 1) {
                icon = faWifi;
                color = "#88c906"
            } else {
                icon = faWifiSlash
                color = "#999"
            }
            this.snackbar.openFromComponent(IconSnackBarComponent, {
                data: {
                    text: "Your are " + ((status == 1) ? "connected to" : "disconnected from")+" the internet.",
                    icon: icon,
                    color: color,

                },

                horizontalPosition: "start",
                duration: 3000
            });
        });

    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (window.screen.width <= 570) { // 768px portrait
            this.isMobile = true;
        }

        if (window.screen.width >= 768) { // 768px portrait
            this.isMobile = false;
        }
    }

    ngOnInit() {

        if (window.screen.width <= 570) { // 768px portrait
            this.isMobile = true;
        }

        if (window.screen.width >= 768) { // 768px portrait
            this.isMobile = false;
        }
        // this.Search(this.searchField.value)
        // });
        this.translate.use(this.registry.currentLang);
        if (this.deviceService.isMobile()) {
            // this.showMobileAppsDownloadComp = true;
        }
    }

    toggle() {


        this.sideBarService.toggle();

    }

    removeSearchBarValue(event) {
        event.preventDefault();
        localStorage.setItem('searchKeyword', '');
    }

    ngAfterViewInit() {
        // this.elementPosition = this.headerElement.nativeElement.offsetTop + 100;
    }

    @HostListener('window:scroll', ['$event'])
    handleScroll() {
        const windowScroll = window.pageYOffset;
        if (windowScroll >= this.elementPosition && window.innerWidth > 100) {
            this.sticky = true;
        } else {
            this.sticky = false;
        }
    }

    goToSignupPage() {
        this.router.navigate(['/signUp']);

    }

    Search(search
               :
               string
    ) {
        // this.searchService.addSearchVal(search);
        //
        // if(search.length > 0 ){
        //   this.searchService.setSearchFlag();
        // }else {
        //   this.searchService.clearSearchFlag();
        // }
        // this.customerSearchService.emitData(search);
        // console.log(search);
    }

}
